export const CLASS_LIST_ITEM = 'list-item';
export const CLASS_LIST_ITEM_CONTAINER = 'list-item__container';
export const CLASS_LIST_ITEM_LOADING = CLASS_LIST_ITEM + '--loading';
export const CLASS_LIST_ITEM_DRAGGABLE = CLASS_LIST_ITEM + '--draggable';
